import { AppSubjectEnum } from '@splitsecondconnect/ultramarine-shared';
import { ModulesEnum } from '../enums/modules.enum';

/**
 * Maps a {@link ModulesEnum} to an {@link AppSubjectEnum}.
 * @param module - The module to map.
 * @returns The corresponding subject name.
 */
export function mapModuleToSubject(module: ModulesEnum): AppSubjectEnum {
  switch (module) {
    case ModulesEnum.AGENTS:
      return AppSubjectEnum.AGENT;
    case ModulesEnum.AGENT_CATEGORIES:
      return AppSubjectEnum.AGENT_CATEGORY;
    case ModulesEnum.CUSTOMERS:
      return AppSubjectEnum.CUSTOMER;
    case ModulesEnum.DAMAGES:
      return AppSubjectEnum.VEHICLE_DAMAGE;
    case ModulesEnum.INSURANCES:
      return AppSubjectEnum.VEHICLE_INSURANCE;
    case ModulesEnum.LOCATIONS:
      return AppSubjectEnum.LOCATION;
    case ModulesEnum.MAINTENANCES:
      return AppSubjectEnum.VEHICLE_MAINTENANCE;
    case ModulesEnum.RENTER_ACCOUNTS:
      return AppSubjectEnum.ACCOUNT;
    case ModulesEnum.RENTALS:
      return AppSubjectEnum.RENTAL_AGREEMENT;
    case ModulesEnum.RESERVATIONS:
      return AppSubjectEnum.RENTAL_RESERVATION;
    case ModulesEnum.ROAD_TAXES:
      return AppSubjectEnum.VEHICLE_ROAD_TAX;
    case ModulesEnum.ROAD_WORTHY_CHECKS:
      return AppSubjectEnum.VEHICLE_ROAD_WORTHY_CHECK;
    case ModulesEnum.SUPPLIERS:
      return AppSubjectEnum.SUPPLIER;
    case ModulesEnum.TRANSACTIONS:
      return AppSubjectEnum.TRANSACTION;
    case ModulesEnum.VEHICLES:
      return AppSubjectEnum.VEHICLE;
    case ModulesEnum.VEHICLE_GROUPS:
      return AppSubjectEnum.VEHICLE_GROUP;
    case ModulesEnum.VEHICLE_CATEGORIES:
      return AppSubjectEnum.VEHICLE_CATEGORY;
    case ModulesEnum.VEHICLE_COLORS:
      return AppSubjectEnum.VEHICLE_COLOR;
    case ModulesEnum.VEHICLE_MAKES:
      return AppSubjectEnum.VEHICLE_MAKE;
    case ModulesEnum.VEHICLE_MODELS:
      return AppSubjectEnum.VEHICLE_MODEL;
    case ModulesEnum.TAGS:
      return AppSubjectEnum.TAG;
    default:
      throw new Error(`Unsupported module: ${module}`);
  }
}
